import {
  Box,
  CheckCircleIcon,
  Stack,
  Typography
} from '@customink/pigment-react';
import PropTypes from 'prop-types';
import React from 'react';

export default function KeyBenefitItem({
  description,
  noBackground = false,
  title
}) {
  return (
    <Box
      sx={{
        borderRadius: '0.5rem',
        display: 'flex',
        flex: '1',
        flexDirection: 'column',
        minWidth: 0,
        ...(!noBackground && {
          backgroundColor: 'rgba(0,0,0,0.04)',
          padding: '0.75rem 1rem'
        })
      }}>
      <Box sx={{flex: 1}}>
        <Stack gap="0.5rem" sx={{height: '100%'}}>
          <Stack direction="row" gap="0.375rem" alignItems="center">
            <CheckCircleIcon
              sx={{
                color: '#FA3C00',
                flexShrink: 0,
                height: '1.5rem',
                width: '1.5rem'
              }}
            />
            <Typography
              sx={{
                color: 'rgba(0,0,0,0.86)',
                flex: 1,
                fontFamily: '"Sharp Sans", sans-serif',
                fontSize: '1rem',
                fontWeight: 'bold',
                lineHeight: 1.25,
                minWidth: 0
              }}>
              {title}
            </Typography>
          </Stack>
          <Typography
            sx={{
              color: 'rgba(0,0,0,0.86)',
              fontFamily: '"Sharp Sans", sans-serif',
              fontSize: '0.875rem',
              fontWeight: 500,
              lineHeight: 1.5
            }}>
            {description}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
}

KeyBenefitItem.propTypes = {
  description: PropTypes.string.isRequired,
  noBackground: PropTypes.bool,
  title: PropTypes.string.isRequired
};
